export default __webpack_public_path__ + "static/media/sun.9dd04db6.jpg";